import { useIntl } from "react-intl";

import { classNames } from "tools/ui";
import { STYLE_FOCUS_RING } from "../constants";

function SectionToggle({
  name,
  checked,
  onChange,
  onText = "melhous.dash.section_on",
  offText = "melhous.dash.section_off",
}) {
  const intl = useIntl();
  const stateId = checked ? onText : offText;

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={() => onChange(name, !checked)}
      className={classNames(
        "flex min-h-16 w-full items-center justify-between gap-4 rounded-lg border bg-white px-4 py-3 text-left transition-colors",
        checked ? "border-sky-900" : "border-neutral-200",
        STYLE_FOCUS_RING,
      )}
    >
      <span className="flex min-w-0 flex-col">
        <span className="font-medium text-neutral-800">
          {intl.formatMessage({ id: `melhous.${name}` })}
        </span>
        <span className="text-sm text-neutral-500">
          {intl.formatMessage({ id: stateId })}
        </span>
      </span>
      <span
        className={classNames(
          "relative h-6 w-11 shrink-0 rounded-full transition-colors",
          checked ? "bg-sky-900" : "bg-neutral-300",
        )}
      >
        <span
          className={classNames(
            "absolute left-0.5 top-0.5 size-5 rounded-full bg-white shadow transition-transform",
            checked && "translate-x-5",
          )}
        />
      </span>
    </button>
  );
}

export default SectionToggle;
